import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Grid } from 'react-bootstrap';
import Modal from '../../common/Modal/Modal';
import analyticsContext from '../../analytics/Analytics';
import {
  setExperienceBookingModal,
  setExperienceBookingInProgress,
  setExperienceBookingSuccess,
} from '../../../actions/experiences';
import BookingModalsParams from '../BookingModal/BookingModalsParams';
import { FancyWhiteButton } from '../../common/FancyButton/FancyButton';
import { Button } from 'react-bootstrap';
import CalendarImage from '../../../resources/Calendar.png';
import { theme } from '../../../../../themes';

class BookingFailureModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      app: 'shs',
    };

    this.partnerButtonStyles = {
      backgroundColor: theme.colors.primaryAccent,
      borderColor: theme.colors.primaryAccent,
      color: theme.colors.experiencesCallMeModalButtonTextColor,
    };
  }
  componentDidMount() {
    analyticsContext
      .withAdvancedProps({
        section: 'bookingFailure',
        mode: this.props && this.props.mode,
        experience: this.props && this.props.megaUseCase,
      })
      .screenEvent();
  }
  renderCallMeLaterFailure() {
    const callMeLaterModalParams = BookingModalsParams[this.state.app]['callMeLater'].failureModal;
    const title = callMeLaterModalParams.title;
    const text = callMeLaterModalParams.text;
    return (
      <Modal>
        <Grid>
          <div className="failureMsgModalContent">
            <p className="title">{title}</p>
            <p className="text">{text}</p>
            <a
              className="btn inGreen"
              style={this.partnerButtonStyles}
              onClick={() => {
                this.props.setExperienceBookingInProgress(false); // Reenable items on booking modal
                this.props.setExperienceBookingModal(false); // Close the booking modal
                this.props.setExperienceBookingSuccess(null); // Close the failure modal
              }}
            >
              Okay
            </a>
          </div>
        </Grid>
      </Modal>
    );
  }

  renderCallMeNowFailure = () => {
    const callMeLaterModalParams = BookingModalsParams[this.state.app]['callMeNow'].failureModal;
    const title = callMeLaterModalParams.title;
    const text = callMeLaterModalParams.text;
    return (
      <Modal>
        <Grid>
          <div className="failureMsgModalContent">
            <p className="title">{title}</p>
            <p className="text">{text}</p>
            <a
              className="btn inGreen"
              style={this.partnerButtonStyles}
              onClick={() => {
                this.props.setExperienceBookingInProgress(false); // Reenable items on booking modal
                this.props.setExperienceBookingModal('callMeLater'); // Close the booking modal
                this.props.setExperienceBookingSuccess(null); // Close the failure modal
              }}
            >
              Book Session
            </a>
            <a
              className="btn noBorderGreen"
              style={{ color: theme.colors.experiencesCallMeModalButtonTextColor }}
              onClick={() => {
                this.props.setExperienceBookingInProgress(false); // Reenable items on booking modal
                this.props.setExperienceBookingModal(false); // Open the scheduler booking modal
                this.props.setExperienceBookingSuccess(null); // Close the failure modal
              }}
            >
              Try Later
            </a>
          </div>
        </Grid>
      </Modal>
    );
  };

  render() {
    return this.props.mode === 'callMeLater' ? this.renderCallMeLaterFailure() : this.renderCallMeNowFailure();
  }
}

BookingFailureModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state /*state, ownProps*/) => ({
  mode: state.experiences.experienceBookingModal,
  appointmentData: state.experiences.appointmentData,
  maxCustomerWaitTime: state.callMeNow.maxCustomerWaitTime,
  megaUseCase: state.experiences.experienceSelected.megaUseCase,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setExperienceBookingSuccess,
      setExperienceBookingModal,
      setExperienceBookingInProgress,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookingFailureModal));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/BookingFailureModal/BookingFailureModal.js